import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Linkedin, Facebook } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_business-web-creator-3/artifacts/5uzr9n01_IMG_2146.jpeg" 
                alt="PRO HOME Développement" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-[#71717A] mb-6">
              Partenaire de confiance pour les bailleurs sociaux et la promotion immobilière. 
              Expertise BTP et engagement qualité.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 bg-[#18181B] rounded-sm flex items-center justify-center hover:bg-[#F25F19] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-[#18181B] rounded-sm flex items-center justify-center hover:bg-[#F25F19] transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wide">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="footer-link">Accueil</Link>
              </li>
              <li>
                <Link to="/a-propos" className="footer-link">À propos</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link">Services</Link>
              </li>
              <li>
                <Link to="/projets" className="footer-link">Projets</Link>
              </li>
              <li>
                <Link to="/partenaires" className="footer-link">Partenaires</Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wide">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="footer-link">Construction BTP</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link">Habitat Social</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link">Promotion Immobilière</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link">Maîtrise d'Ouvrage</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wide">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#F25F19] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-[#71717A] text-sm">Direction Commerciale</p>
                  <a href="tel:0134908690" className="mono hover:text-[#F25F19] transition-colors">
                    01.34.90.86.90
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#F25F19] mt-0.5 flex-shrink-0" />
                <a href="mailto:contact@pro-home-developpement.com" className="hover:text-[#F25F19] transition-colors">
                  contact@pro-home-developpement.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#F25F19] mt-0.5 flex-shrink-0" />
                <span className="text-[#71717A]">66 avenue des Champs Élysées<br />75008 Paris</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#18181B]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#71717A] text-sm">
              © {currentYear} PRO HOME Développement. Tous droits réservés.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="footer-link">Mentions légales</a>
              <a href="#" className="footer-link">Politique de confidentialité</a>
              <a href="https://www.mesfinancesprecieuses.fr" target="_blank" rel="noopener noreferrer" className="footer-link">Partenaire</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
